import { Link } from 'react-router-dom';
import { useContentPendingCountQuery } from '../api/queries';
import { useAuth } from '../hooks/useAuth';

export default function ContentApprovalsBadge() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const { data } = useContentPendingCountQuery(isAdmin);

  if (!isAdmin) return null;

  const count = data?.count ?? 0;

  return (
    <Link
      to="/content-approvals"
      title={count > 0 ? `${count} content submission${count === 1 ? '' : 's'} pending review` : 'Content approvals'}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: 8,
        background: count > 0 ? '#fef3c7' : 'transparent',
        color: count > 0 ? '#92400e' : '#64748b',
        textDecoration: 'none',
        marginRight: 12,
        transition: 'background 0.15s',
      }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
      {count > 0 && (
        <span
          style={{
            position: 'absolute',
            top: 2,
            right: 2,
            background: '#dc2626',
            color: 'white',
            fontSize: 10,
            fontWeight: 700,
            minWidth: 16,
            height: 16,
            padding: '0 4px',
            borderRadius: 8,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
          }}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
}
